import {ExtendedLink, HttpMethod} from '../types';
import {httpService} from '@malt/http-client';

/**
 * @warn Only usable in a browser environnement
 * For Nuxt, use `useUniversalFetch`
 */
export async function clientFetch<T>(
    {url, method = HttpMethod.GET}: ExtendedLink,
    params?: Record<string, any>,
    logger?: boolean,
): Promise<T | null> {
    try {
        const [data, error] = await httpService.request<T>(
            {
                url,
                method,
                ...(params && {params}),
            },
            logger,
        );
        if (error) {
            return Promise.reject(error);
        } else {
            return data;
        }
    } catch (e) {
        return Promise.reject(e);
    }
}
